import { render } from "./Services.vue?vue&type=template&id=77c4ad8d"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=77c4ad8d&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/api2-production/workspace/api2/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__